import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import AssistantFAB from './AssistantFAB';
import GlobalAssistant from './GlobalAssistant';
import BatchActivityBridge from './BatchActivityBridge';
import { ActivityProvider } from './ActivityProvider';
import { Icons as I } from '../pack-icons';

export default function AppShell({ topbarTitle, topbarSub, topbarRight, initialActivity = null, children }) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setMobileNavOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!mobileNavOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') setMobileNavOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [mobileNavOpen]);

  return (
    <ActivityProvider initial={initialActivity}>
      <BatchActivityBridge />
      <div className={`app-shell ${mobileNavOpen ? 'is-mobile-nav-open' : ''}`}>
        {mobileNavOpen && (
          <div
            className="app-shell-backdrop"
            onClick={() => setMobileNavOpen(false)}
            role="presentation"
          />
        )}
        <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
        <div className="app-main">
          <Topbar
            title={topbarTitle}
            sub={topbarSub}
            right={topbarRight}
            onMobileMenuToggle={() => setMobileNavOpen((open) => !open)}
            mobileNavOpen={mobileNavOpen}
          />
          <main className="app-content">{children}</main>
        </div>
        <AssistantFAB />
        <GlobalAssistant />
      </div>
    </ActivityProvider>
  );
}
